var _g, _rect, _g2, _rect2, _g3, _rect3, _g4, _rect4, _circle, _circle2, _circle3, _path, _path2, _path3, _circle4, _rect5, _g5, _rect6, _g6, _rect7, _g7, _rect8, _path4, _path5, _circle5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveTotalPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 154,
    viewBox: "0 0 277 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13083_16003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71.5848,
    cy: 34.5856,
    r: 16,
    transform: "rotate(-6 71.5848 34.5856)",
    fill: "#FFC844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0514 26.4854C70.2379 25.8593 71.0877 25.77 71.4002 26.3437L73.5854 30.3542C73.7171 30.596 73.9731 30.7438 74.2484 30.737L78.8142 30.6241C79.4673 30.608 79.8149 31.3886 79.3659 31.8631L76.2269 35.1806C76.0376 35.3807 75.9761 35.6698 76.0677 35.9296L77.586 40.237C77.8031 40.8531 77.1681 41.4249 76.5781 41.1445L72.4529 39.1843C72.2042 39.0661 71.9102 39.097 71.6915 39.2643L68.064 42.0394C67.5451 42.4363 66.8051 42.0091 66.8895 41.3613L67.479 36.8323C67.5145 36.5592 67.3943 36.2891 67.1676 36.1328L63.4074 33.5404C62.8696 33.1696 63.0472 32.3338 63.6894 32.2138L68.1789 31.375C68.4496 31.3244 68.6693 31.1266 68.7479 30.8626L70.0514 26.4854Z",
    fill: "#24284E"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 20.3457,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-6 54 20.3457)",
    stroke: "#FFF2D8",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13083_16003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 186.981,
    cy: 25.983,
    r: 20,
    transform: "rotate(6 186.981 25.983)",
    fill: "#FFC844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.212 15.6798C187.602 14.9628 188.665 15.0744 188.898 15.857L190.527 21.3286C190.625 21.6585 190.9 21.9057 191.238 21.969L196.85 23.0175C197.653 23.1675 197.875 24.2123 197.203 24.6758L192.502 27.9163C192.219 28.1117 192.069 28.4492 192.113 28.7906L192.85 34.4518C192.955 35.2616 192.03 35.7957 191.382 35.2995L186.848 31.8307C186.574 31.6215 186.207 31.5829 185.896 31.7306L180.739 34.1809C180.002 34.5314 179.208 33.8167 179.479 33.0465L181.377 27.6622C181.492 27.3375 181.415 26.9761 181.178 26.726L177.255 22.5792C176.693 21.986 177.128 21.0102 177.944 21.0304L183.651 21.1715C183.995 21.1801 184.315 20.9953 184.48 20.693L187.212 15.6798Z",
    fill: "#24284E"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 169.181,
    y: 4.00195,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(6 169.181 4.00195)",
    stroke: "#FFF2D8",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_13083_16003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 105.721,
    cy: 33.7231,
    r: 20,
    transform: "rotate(12 105.721 33.7231)",
    fill: "#FFC844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.027 23.5012C107.491 22.8288 108.535 23.0509 108.685 23.8536L109.734 29.4655C109.797 29.8039 110.044 30.0785 110.374 30.1767L115.846 31.8062C116.628 32.0392 116.74 33.1015 116.023 33.4922L111.01 36.2236C110.708 36.3883 110.523 36.7083 110.531 37.0525L110.672 42.7597C110.693 43.5761 109.717 44.0105 109.124 43.4492L104.977 39.5255C104.727 39.2889 104.365 39.2121 104.041 39.3265L98.6564 41.2243C97.8862 41.4958 97.1715 40.702 97.522 39.9645L99.9722 34.8081C100.12 34.4971 100.081 34.1296 99.8722 33.8562L96.4034 29.3219C95.9072 28.6733 96.4413 27.7483 97.2511 27.8537L102.912 28.5906C103.254 28.6351 103.591 28.4848 103.787 28.2014L107.027 23.5012Z",
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90.3164,
    y: 10.002,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(12 90.3164 10.002)",
    stroke: "#FFF2D8",
    strokeWidth: 2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_13083_16003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 142,
    cy: 91,
    r: 44,
    fill: "#FFC844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.438 66.2362C128.675 64.4553 130.945 63.8472 132.041 65.2709L139.227 74.6082C139.689 75.2084 140.448 75.4997 141.193 75.3628L152.782 73.2325C154.549 72.9077 155.828 74.8784 154.813 76.3605L148.153 86.0806C147.725 86.7054 147.683 87.5172 148.043 88.1833L153.65 98.5463C154.505 100.126 153.026 101.953 151.303 101.445L140.001 98.1149C139.274 97.9008 138.489 98.1112 137.967 98.6598L129.844 107.195C128.605 108.496 126.411 107.654 126.362 105.858L126.036 94.0801C126.015 93.323 125.573 92.6412 124.889 92.3142L114.262 87.2261C112.642 86.4503 112.765 84.1037 114.457 83.5015L125.558 79.5522C126.272 79.2983 126.783 78.6666 126.883 77.9158L128.438 66.2362Z",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.856 86.174C155.952 84.7503 158.222 85.3585 158.459 87.1394L159.347 93.8123C159.447 94.563 159.959 95.1948 160.672 95.4486L167.015 97.705C168.707 98.3072 168.83 100.654 167.21 101.43L161.138 104.337C160.455 104.664 160.012 105.345 159.991 106.102L159.805 112.832C159.756 114.628 157.562 115.47 156.323 114.168L151.682 109.292C151.16 108.743 150.375 108.533 149.649 108.747L143.191 110.65C141.468 111.157 139.989 109.331 140.844 107.751L144.047 101.83C144.408 101.164 144.365 100.352 143.937 99.7276L140.132 94.1742C139.117 92.6922 140.397 90.7214 142.164 91.0462L148.785 92.2633C149.53 92.4003 150.288 92.109 150.75 91.5088L154.856 86.174Z",
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 47,
    width: 88,
    height: 88,
    rx: 44,
    stroke: "#FFF2D8",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 59.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 222.5,
    cy: 10.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 12.5,
    r: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5L34 28",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 75L17 79.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M241 34.5L260.5 32",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.5,
    cy: 54.5,
    r: 1.5,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 34 154)",
    fill: "#24284E"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_13083_16003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 66.0032,
    r: 24,
    transform: "rotate(-12 200 66.0032)",
    fill: "#FFC844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.442 54.1599C196.622 53.1967 197.876 52.9302 198.432 53.737L202.321 59.3772C202.555 59.7173 202.96 59.8976 203.37 59.8443L210.164 58.96C211.135 58.8335 211.776 59.9436 211.181 60.7219L207.018 66.163C206.767 66.4911 206.721 66.9321 206.898 67.3052L209.838 73.4929C210.259 74.378 209.401 75.3305 208.477 75.0048L202.016 72.7274C201.626 72.59 201.193 72.6822 200.893 72.9661L195.916 77.6747C195.205 78.3482 194.034 77.8268 194.058 76.8472L194.227 69.9985C194.237 69.5855 194.016 69.2015 193.653 69.0039L187.637 65.7262C186.777 65.2574 186.911 63.9826 187.85 63.703L194.416 61.7477C194.812 61.6297 195.108 61.3002 195.184 60.8942L196.442 54.1599Z",
    fill: "white"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 171.534,
    y: 47.5176,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(-12 171.534 47.5176)",
    stroke: "#FFF2D8",
    strokeWidth: 2
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_13083_16003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 147,
    cy: 28.003,
    r: 24,
    transform: "rotate(-10 147 28.003)",
    fill: "#FFC844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.858 16.0439C144.072 15.0875 145.334 14.8649 145.862 15.6906L149.551 21.4631C149.774 21.8112 150.172 22.0056 150.584 21.9666L157.404 21.3199C158.379 21.2274 158.981 22.3591 158.359 23.1162L154.009 28.4088C153.747 28.7279 153.685 29.167 153.849 29.5461L156.572 35.8326C156.961 36.7319 156.071 37.6539 155.158 37.296L148.781 34.7945C148.396 34.6437 147.959 34.7207 147.65 34.994L142.512 39.5259C141.777 40.1742 140.625 39.6123 140.684 38.6341L141.092 31.7955C141.116 31.3831 140.908 30.9916 140.553 30.7815L134.655 27.2958C133.811 26.7972 133.99 25.528 134.938 25.2812L141.568 23.5563C141.968 23.4522 142.276 23.1333 142.366 22.7301L143.858 16.0439Z",
    fill: "#24284E"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 119.197,
    y: 8.53516,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(-10 119.197 8.53516)",
    stroke: "#FFF2D8",
    strokeWidth: 2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_13083_16003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81.6332,
    cy: 71.635,
    r: 28,
    transform: "rotate(-16 81.6332 71.635)",
    fill: "#FFC844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5293 58.1426C76.6604 57.0069 78.0978 56.5947 78.8108 57.4884L83.7954 63.7362C84.096 64.113 84.5821 64.2899 85.0545 64.1945L92.8889 62.6124C94.0096 62.3861 94.8458 63.6259 94.2162 64.5801L89.8145 71.2514C89.5491 71.6537 89.531 72.1707 89.7677 72.5905L93.6933 79.5526C94.2548 80.5485 93.3342 81.7269 92.2321 81.423L84.5271 79.2983C84.0625 79.1701 83.5652 79.3127 83.2391 79.6676L77.8308 85.5525C77.0572 86.3942 75.652 85.8828 75.6005 84.7407L75.2402 76.7562C75.2185 76.2748 74.9292 75.8459 74.4909 75.6454L67.2228 72.3203C66.1832 71.8447 66.2354 70.3503 67.3057 69.9483L74.788 67.1384C75.2392 66.9689 75.5577 66.5613 75.6129 66.0825L76.5293 58.1426Z",
    fill: "#24284E"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 52.4375,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-16 47 52.4375)",
    stroke: "#FFF2D8",
    strokeWidth: 1.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 96C62 94.8954 62.8954 94 64 94H84.2654C85.2607 94 86.1046 94.7319 86.2453 95.7172L89.7547 120.283C89.8954 121.268 90.7393 122 91.7346 122H192.265C193.261 122 194.105 121.268 194.245 120.283L197.755 95.7172C197.895 94.7319 198.739 94 199.735 94H220C221.105 94 222 94.8954 222 96V122V148C222 149.105 221.105 150 220 150H190H94H64C62.8954 150 62 149.105 62 148V122V96Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M249 84L272 87.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 127.5,
    r: 1.5,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13083_16003"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 20.3457,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-6 54 20.3457)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13083_16003"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.181,
    y: 4.00195,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(6 169.181 4.00195)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_13083_16003"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90.3164,
    y: 10.002,
    width: 40,
    height: 40,
    rx: 20,
    transform: "rotate(12 90.3164 10.002)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_13083_16003"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 47,
    width: 88,
    height: 88,
    rx: 44,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_13083_16003"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.534,
    y: 47.5176,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(-12 171.534 47.5176)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_13083_16003"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.197,
    y: 8.53516,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(-10 119.197 8.53516)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_13083_16003"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 52.4375,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-16 47 52.4375)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveTotalPoints);
export default __webpack_public_path__ + "static/media/collective-total-points.961594ee45d93a45945113a479a06511.svg";
export { ForwardRef as ReactComponent };